import { rankWith, isIntegerControl } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputControlComponent } from 'src/components/JsonForm/controls/InputControl';

export const IntegerControlComponent = (props: ControlProps) => {
    return <InputControlComponent {...props} type="number" />;
};

export const IntegerControlTester = rankWith(
    4, //increase rank as needed
    isIntegerControl,
);

export const IntegerControl = withJsonFormsControlProps(IntegerControlComponent);
